import Vue from 'vue'
import Cookies from 'js-cookie'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import Element from 'element-ui'
import './styles/element-variables.scss'
import zhCNLang from 'element-ui/lib/locale/lang/zh-CN'// 如果使用中文语言包请默认支持，无需额外引入，请删除该依赖
import '@/styles/index.scss' // global css
import App from './App'
import store from './store'
import router from './router'
import './utils/getWebTitle'
import './icons' // icon
import './permission' // permission control
import './utils/error-log' // error log
import * as filters from './filters' // global filters
import VueAMap from 'vue-amap'
import { keepTwoDecimalFull, roundNumber } from '@/utils/publicFun'
import echarts from 'echarts'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)
Vue.prototype.$echarts = echarts
// 全局挂载四舍五入方法
Vue.prototype.$toFixed = keepTwoDecimalFull
// 全局引入dataVh
import dataV from '@jiaminghi/data-view'
Vue.use(dataV)
Vue.use(roundNumber)
Vue.use(VueAMap)
Vue.prototype.$EventBus = new Vue()
VueAMap.initAMapApiLoader({
  key: '832903da05b2c98a8be515547bf8fc57',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geolocation',
    'AMap.Geocoder'
  ],
  v: '1.4.11'
})

// console.log(router);
/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
if (process.env.NODE_ENV === 'production') {
  const { mockXHR } = require('../mock')
  mockXHR()
}

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  locale: zhCNLang // 如果使用中文，无需设置，请删除
})

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false

// 禁用console.log
// console.log = function(){}


Vue.mixin({
  methods: {
    publicFunction() {
      console.log('public')
    }
  }
})
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
